<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="50%" scrollable>
      <v-btn
        :disabled="disabled"
        icon
        color="primary"
        dark
        flat
        slot="activator"
        ><v-icon>mdi-qrcode</v-icon></v-btn
      >
      <v-card v-if="dialog">
        <v-card-title class="grey lighten-3">
          <span class="title">{{
            $t('screener.physical.tickets.dialog.title')
          }}</span>
          <v-spacer></v-spacer>
          <v-btn small color="primary" v-print="'#ticket'"
            ><v-icon small class="mr-1">$vuetify.icons.rms_print</v-icon
            >{{ $t('screener.btn.print') }}</v-btn
          >
          <v-btn
            small
            :loading="isGeneratingPdf"
            color="primary"
            @click.stop="generateReport"
            ><v-icon small class="mr-1"
              >$vuetify.icons.rms_media_download</v-icon
            >
            {{ $t('ticket.download') }}</v-btn
          >
          <v-btn small color="primary" @click.stop="cancelDialog = true"
            ><v-icon small class="mr-1">$vuetify.icons.rms_delete</v-icon
            >{{ $t('ticket.cancel') }}</v-btn
          >
          <ConfirmationDialog
            v-if="cancelDialog"
            :dialog="cancelDialog"
            @confirm="cancelBooking"
            @cancel="cancelDialog = false"
          ></ConfirmationDialog>
        </v-card-title>
        <v-card-text v-if="screener && booking">
          <vue-html2pdf
            :html-to-pdf-options="pdf_options"
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="false"
            :paginate-elements-by-height="1100"
            :filename="screener.title"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            @hasDownloaded="pdfGenerated"
            ref="html2Pdf"
            pdf-content-width="100%"
          >
            <section slot="pdf-content">
              <Ticket
                v-if="booking.seat_indexes.length"
                :booking="booking"
                :screener="screener"
                :consumer_email="consumer_email"
                :qrCode="booking.code"
              ></Ticket>
            </section>
          </vue-html2pdf>
        </v-card-text>
        <v-card-text>
          <v-container grid-list-md>
            <Ticket
              v-if="booking.seat_indexes.length"
              :booking="booking"
              :screener="screener"
              :consumer_email="consumer_email"
              :qrCode="booking.code"
              id="ticket"
            ></Ticket>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="dialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import Ticket from './Ticket';
import VueHtml2pdf from 'vue-html2pdf';
import ConfirmationDialog from '@/components/dialogBox/Confirmation';
import i18n from '@/i18n';
import DEFINES from '@/defines';

export default {
  props: {
    screener: {
      type: Object,
      default: null,
    },
    booking: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    consumer_email: {
      type: String,
      default: null,
    },
  },
  name: 'TicketsDialog',
  data() {
    return {
      dialog: false,
      cancelDialog: false,
      isGeneratingPdf: false,
      pdf_options: {
        enableLinks: true,
        image: {
          type: 'jpeg',
          quality: 0.5,
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
          scrollX: 0,
          scrollY: 0,
        },
      },
    };
  },
  components: {
    Ticket,
    VueHtml2pdf,
    ConfirmationDialog,
  },
  methods: {
    async cancelBooking() {
      try {
        let response = await this.$store.dispatch('booking/cancelBooking', {
          booking_id: this.booking.id,
          screener_id: this.screener.id,
        });
        this.cancelDialog = false;
        if (
          !this.DEFINES.REFUND_SUPPORTING_GATEWAYS.includes(
            response.booking.purchase.payment_gateway
          )
        ) {
          this.$store.dispatch('app/showMessage', {
            message: i18n.t(
              'screener.booking.seats.manual.cancelation.required.message',
              {
                payment_gateway: response.booking.purchase.payment_gateway,
              }
            ),
            color: 'success',
          });
        } else {
          this.$store.dispatch('app/showMessage', {
            message: i18n.t('screener.booking.seats.cancelled.success.message'),
            color: 'success',
          });
        }
        this.$emit('onCancelled');
      } catch (error) {
        this.loader = false;
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      }
    },

    pdfGenerated(event) {
      this.isGeneratingPdf = false;
    },

    generateReport() {
      this.isGeneratingPdf = true;
      this.$refs.html2Pdf.generatePdf();
    },
  },
};
</script>
